import { forwardRef } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

import {
  SELECT_TRIGGER_ICON,
  type TSelectTriggerElement,
  type TSelectTriggerProps,
} from "@/ui/components/form/Select/Select.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { cn } from "@/ui/lib/utils";

export const SelectTrigger = forwardRef<TSelectTriggerElement, TSelectTriggerProps>(
  (
    {
      children,
      className,
      error,
      ...props
    },
    ref,
  ) => (
    <SelectPrimitive.Trigger
      data-component="SelectTrigger"
      ref={ref}
      aria-invalid={!!error}
      className={cn(
        "peer",
        "flex w-full box-border items-center justify-between gap-2 rounded-sys-sm border border-solid border-component-input-default bg-component-input-focused data-[placeholder]:bg-component-input-default shadow-sm p-2",
        "overflow-hidden",
        "disabled:text-foreground-muted disabled:cursor-not-allowed",
        "font-sys-default",
        "focus:outline focus:outline-1 focus:outline-offset-0 focus:outline-sys-black focus:ring-4 focus:ring-focus-primary focus:bg-component-input-focused",
        error && "border-component-input-destructive focus:ring-focus-destructive focus:outline-transparent",
        className,
      )}
      {...props}
    >
      { children }
      <SelectPrimitive.Icon asChild>
        <Icon
          icon={SELECT_TRIGGER_ICON}
          aria-hidden="true"
          size="sm"
          className="shrink-0"
        />
      </SelectPrimitive.Icon>
    </SelectPrimitive.Trigger>
  ),
);

SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;
